import React from "react";

import { TSelectOption } from "@amphore-dev/amphore-lib";

import { cn } from "@/utils/cn";

/**
 * V2 Select's `renderOption` — a logo (or, failing that, a color dot) next
 * to the label, for ViewSelect/ClientSelect/CompanySelect/
 * ProjectSelect. `option.value` is the whole domain object (a company, a
 * project, ...), not just its id, precisely so this can reach `.logo`/
 * `.color`/`.name` directly.
 */
export const renderSwatchOption = <
	T extends { logo?: string | null; color?: string | null; name?: string },
>(
	rounded = false
) => {
	const Render = (option: TSelectOption<T>) => (
		<span className="flex items-center gap-2">
			{option.value.logo ? (
				<img
					src={option.value.logo}
					alt={option.value.name ?? ""}
					className={cn([
						"max-h-6 max-w-6",
						rounded && "rounded-full",
					])}
				/>
			) : option.value.color ? (
				<span
					className={cn([
						"h-2 w-2 shrink-0",
						rounded && "rounded-full",
					])}
					style={{ backgroundColor: option.value.color }}
				/>
			) : null}
			{option.label}
		</span>
	);
	return Render;
};
